<template>
  <v-app
    class="grey lighten-4"
  >
    <v-navigation-drawer
      v-if="$store.state.loggedIn && !$store.state.init"
      v-model="drawer"
      persistend
      clipped
      app
      fixed
    >
      <v-list
        light
        two-lines
      >
        <v-list-item>
          <v-list-item-action>
            <v-avatar
              size="42px"
              class="grey lighten-4 mr-2"
            >
              <img :src="$store.state.managerStore.managerImages[$store.state.managerStore.imageId]" alt="avatar">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $store.state.managerStore.name }}
            </v-list-item-title>
            {{ $store.state.moneyStore.giro | currency }}
          </v-list-item-content>
        </v-list-item>
        <v-divider />
      </v-list>
      <v-list
        light
        two-lines
      >
        <template
          v-for="item in drawerItems"
        >
          <v-divider
            v-if="item.divider"
            :key="item.key"
          />
          <v-list-group
            v-else-if="item.group"
            :key="item.title"
            v-model="mannschaftShow"
            :prepend-icon="item.icon"
            @click="mannschaftShow? !mannschaftShow: $router.push({'path': item.to}).catch(err => {})"
            no-action
          >
            <template v-slot:activator>
              <v-list-item class="pl-0">
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item
              v-for="subItem in item.items"
              :key="subItem.title"
              :to="subItem.to"
            >
              <v-list-item-content>
                <v-list-item-title>{{ subItem.title }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.title"
            :to="item.to"
            ripple
            @click="closeGroup()"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title v-if="!item.chatBadge">
                {{ item.title }}
              </v-list-item-title>
              <v-badge
                v-else
              >
                <span slot="badge">
                  {{ ($store.state.newMessageCounter>0)? $store.state.newMessageCounter - 1 : 0 }}
                </span>
                <span>{{ item.title }}</span>
              </v-badge>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      class="primary"
      dark
      app
      clipped-left
      fixed
    >
      <v-app-bar-nav-icon
        v-if="$store.state.loggedIn"
        dark
        @click.stop="drawer = !drawer"
      />
      <v-toolbar-title>
        <router-link
          v-if="!$store.state.loggedIn"
          class="white--text"
          to="/"
        >
          Kegelmanager.de
        </router-link>
        <router-link
          v-else
          class="white--text"
          to="/buero"
        >
          <!-- <img class="headerimg" src="/static/img/logo-header-klein.png" alt="Kegelmanager.de"> -->
          Kegelmanager.de
        </router-link>
      </v-toolbar-title>
      <v-spacer />

      <template v-if="!$store.state.loggedIn">
        <router-link
          class="d-none d-sm-flex white--text links mr-4 pa-2"
          to="/login"
          v-if="!$store.state.matchEvaluationInProgress"
        >
          Log-in
          <v-icon dark>
            mdi-login
          </v-icon>
        </router-link>
        <router-link
          class="d-none d-sm-flex white--text links mr-2 pa-2"
          to="/register"
          v-if="!$store.state.matchEvaluationInProgress"
        >
          Registrieren
          <v-icon dark>
            mdi-account-plus
          </v-icon>
        </router-link>
      </template>
      <template v-else>
        <router-link class="d-none d-sm-flex white--text links mr-4 pa-2 title" to="/finanzen">
          {{ $store.state.moneyStore.giro | currency }}
        </router-link>
        <v-menu
          bottom
          left
          class="d-none d-sm-flex"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              text
              large
              dark
              class="white--text links"
            >
              <v-avatar
                size="42px"
                class="grey lighten-4 mr-2"
              >
                <img :src="$store.state.managerStore.managerImages[$store.state.managerStore.imageId]" alt="avatar">
              </v-avatar>
              {{ $store.state.managerStore.name }}
            </v-btn>
          </template>
          <v-list>
            <template v-for="item in accountItems">
              <v-divider
                v-if="item.divider"
                :key="item.title"
              />
              <v-list-item
                v-else
                :to="item.to"
                :key="item.title"
              >
                <v-list-item-content>
                  <v-list-item-title v-if="item.title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="item.icon">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>

      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <template v-if="!$store.state.loggedIn">
            <v-list-item
              class="hidden-sm-and-up"
              to="/login"
              v-if="!$store.state.matchEvaluationInProgress"
            >
              <v-list-item-content>
                <v-list-item-title>Log-in</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-login</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              class="hidden-sm-and-up"
              to="/register"
              v-if="!$store.state.matchEvaluationInProgress"
            >
              <v-list-item-content>
                <v-list-item-title>Registrieren</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-account-plus</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider class="hidden-sm-and-up" />
          </template>
          <template v-for="item in moreItems">
            <v-divider
              v-if="item.divider"
              :key="item.title"
            />
            <v-list-item
              v-else
              :to="item.to"
              :key="item.title"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer height="auto" class="primary d-block">
      <div style="text-align:right;">
        <span class="white--text">
          Kegelmanager.de &nbsp;&bull;&nbsp;
          <router-link class="link white--text" to="/impressum">Impressum</router-link> &nbsp;&bull;&nbsp;
          <router-link class="link white--text" to="/datenschutz">Datenschutzerklärung und Cookie-Richtlinie</router-link> &nbsp;&bull;&nbsp;© 07.2017 &ndash; {{ new Date().getFullYear() }}
          &nbsp;&bull;&nbsp; Nico Grundmann &nbsp;&bull;&nbsp;
        </span>
      </div>
    </v-footer>

    <v-snackbar
      :timeout="5000"
      :top="true"
      v-model="$store.state.snackbar"
    >
      {{ $store.state.snackbarText }}
      <v-btn
        text
        color="primary"
        @click.native="closeSnackbar"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { ROOT_CLEAR_SNACKBAR } from './store/mutation-types'

export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Startseite',
    // all titles will be injected into this template
    titleTemplate: '%s | Kegelmanager.de',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
  },
  data () {
    return {
      // vm: this,
      drawer: null,
      mannschaftShow: false,
      drawerItems: [
        { icon: 'business', title: 'Büro', to: '/buero', chatBadge: false },
        {
          icon: 'supervisor_account',
          title: 'Mannschaft',
          to: '/mannschaft',
          group: true,
          active: this.mannschaftShow,
          items: [
            { title: 'Übersicht', to: '/mannschaft', active: true },
            { title: 'Aufstellung', to: '/aufstellung' },
            { title: 'Training / Trainingslager', to: '/training' },
            { title: 'Verträge', to: '/vertrag' }
          ]
        },
        { icon: 'today', title: 'Saison', to: '/saison' },
        // { icon: 'shopping_cart', title: 'Ausrüstung', to: '/ausruestung' },
        { icon: 'store', title: 'Bahn', to: '/bahn' },
        { icon: 'directions_car', title: 'Fahrzeug', to: '/fahrzeug' },
        { icon: 'monetization_on', title: 'Finanzen', to: '/finanzen' },
        { icon: 'settings', title: 'Einstellungen', to: '/settings' },
        { divider: true, key: 'Devider1' },
        { icon: 'power_settings_new', title: 'Abmelden', to: '/logout' },
        { divider: true, key: 'Devider2' },
        { icon: 'mdi-hand-heart', title: 'Spenden', to: '/spenden' }
      ],
      moreItems: [
        { icon: 'mdi-history', title: 'Änderungen', to: '/changelog' },
        { divider: true },
        { icon: 'mdi-help', title: 'Hilfe', to: '/help' },
        { divider: true },
        { icon: '', title: 'Impressum', to: '/impressum' },
        { icon: '', title: 'Datenschutz', to: '/datenschutz' },
        { icon: '', title: 'AGB', to: '/agb' }

      ],
      accountItems: [
        { icon: 'settings', title: 'Einstellungen', to: '/settings' },
        { divider: true },
        { icon: 'power_settings_new', title: 'Abmelden', to: '/logout' }
      ],
      interval: null
    }
  },
  methods: {
    closeGroup: function () {
      this.mannschaftShow = false
    },
    closeSnackbar: function () {
      this.$store.commit(ROOT_CLEAR_SNACKBAR)
    },
    checkEvaluation: async function () {
      await this.$store.dispatch('matchEvaluationInProgress')
    }
  },
  destroy: function () {
    // this.$store.commit('chatStore/CHAT_RESET')
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  },
  created: function () {
    this.checkEvaluation()
  },
  mounted: function () {
    this.checkEvaluation()
    this.interval = setInterval(function () {
      this.checkEvaluation()
    }.bind(this), 60000) // 50 sec
  }
}
</script>

<style>
.links{
  text-decoration: none;
  transition: .3s cubic-bezier(.25,.8,.25,1);
}
.links:hover{
  background-color: rgba(255, 255, 255, 0.1);
}
.links.router-link-active{
  background-color: rgba(0, 0, 0, 0.1);
}
.headerimg{
    margin-top: 15px;
}
.training .input-group.input-group--slider label{
  width: 124px !important;
  text-align: right !important;
}
</style>
